module.exports = __webpack_public_path__ + "static/media/forward.5c4ef4b2.svg";